import { PUSH_TABLES, rows, TableName } from '@/db/database'
import { syncEngine } from '@/sync/SyncEngine'

export interface Rejected {
  table: TableName
  id: string
  label: string
  issue_fields: string[]
  created_at?: string
}

const LABELS: Record<string, string> = {
  products: 'Product',
  product_variations: 'Product variant',
  customers: 'Customer',
  terminal_shifts: 'Shift',
  terminal_cash_in_outs: 'Cash in/out',
  orders: 'Sale',
  order_items: 'Sale item',
  order_returns: 'Return',
  order_return_items: 'Return item',
  payment_logs: 'Payment',
  credit_repayments: 'Credit repayment',
  stock_adjustments: 'Stock count',
}

/** Records the server refused (§15.8 U6). They stay on the device until they are fixed and sent again. */
export const getRejected = async (): Promise<Rejected[]> => {
  const all: Rejected[] = []
  for (const table of PUSH_TABLES) {
    for (const row of await rows(table).where('synced').equals(-1).toArray()) {
      all.push({
        table,
        id: row.id,
        label: `${LABELS[table]} ${String(row.order_ref ?? row.name ?? row.temp_id ?? '')}`.trim(),
        issue_fields: row.issue_fields ?? [],
        created_at: row.created_at as string | undefined,
      })
    }
  }
  return all
}

/** Sends a refused record again, e.g. after the missing customer or terminal now exists on the server. */
export const retry = async (table: TableName, id: string) => {
  await rows(table).update(id, { synced: 0, issue_fields: [] })
  syncEngine.requestSync()
}
